import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import {
  getAllMetrics,
} from "../../../redux/actions/MetricsActions/Action";
import TimeRangeIndicator
  from "../../shared/Graph/TimeRangeIndicator/TimeRangeIndicator";
import StackedBarGraph from "../../shared/Graph/StackedBarGraph";
import EmptyGraph from "../../shared/Graph/EmptyGraph";
import Loader from "../../shared/Loader/Loader";
import { isFinite } from "lodash";

const EntityUsageGraph = () => {
  const dispatch = useDispatch();

  const metrics = useSelector((state) => state.metricsReducer.metrics);
  const [isMetricsLoaded, setIsMetricsLoaded] = useState(false);
  const [timeRange, setTimeRange] = useState('week')

  useEffect(() => {
    setIsMetricsLoaded(false)
    dispatch(getAllMetrics({ period: timeRange }))
  }, [dispatch, timeRange])

  useEffect(() => {
    setIsMetricsLoaded(true)
  }, [metrics])

  const entityGraphOptions = {
    scales: {
      xAxes: [{
        stacked: true,
      }],
      yAxes: [{
        stacked: true
      }]
    },
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      enabled: false,
      mode: 'label',
      custom: function(tooltipModel) {
        let tooltipEl = document.getElementById('entity-usage-chartjs-tooltip');

        if (!tooltipEl) {
          tooltipEl = document.createElement('div');
          tooltipEl.id = 'entity-usage-chartjs-tooltip';
          tooltipEl.className = 'chartjs-custom-tooltip';
          document.body.appendChild(tooltipEl);
        }

        if (tooltipModel.opacity === 0) {
          tooltipEl.style.opacity = 0;
          return;
        }

        tooltipEl.classList.remove('above', 'below', 'no-transform');
        if (tooltipModel.yAlign) {
          tooltipEl.classList.add(tooltipModel.yAlign);
        } else {
          tooltipEl.classList.add('no-transform');
        }

        if (tooltipModel.body) {
          const titleLines = tooltipModel.title || [];
          const bodyLines = tooltipModel.body.map(item => item.lines);
          const footerLines = tooltipModel.footer || [];

          let innerHtml = '';

          titleLines.forEach(title => {
            innerHtml += `<div class="chartjs-custom-tooltip__title">${title}</div>`;
          });

          bodyLines.forEach((body, i) => {
            const colors = tooltipModel.labelColors[i];
            const colorBox = `<span class="chartjs-custom-tooltip__color" style="background:${colors.backgroundColor};border-color:${colors.borderColor}"></span>`;
            innerHtml += `<div class="chartjs-custom-tooltip__item">${colorBox}${body}</div>`;
          });

          footerLines.forEach(footer => {
            innerHtml += `<div class="chartjs-custom-tooltip__footer">${footer}</div>`;
          });

          tooltipEl.innerHTML = innerHtml;
        }

        const position = this._chart.canvas.getBoundingClientRect();
        tooltipEl.style.opacity = 1;
        tooltipEl.style.position = 'fixed';
        tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
        tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
        tooltipEl.style.pointerEvents = 'none';
      },
      callbacks: {
        label: (tooltipItem, data) => {
          let label = data.datasets[tooltipItem.datasetIndex].label || '';
          let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || 0;
          if (label) {
            label += `: ${value}`;
          }
          return label
        },
        footer: (tooltipItems, data) => {
          let sum = 0;
          for (let i = 0; i < data.datasets.length; i++) {
            if (isFinite(data.datasets[i].data[tooltipItems[i].index])) {
              sum += data.datasets[i].data[tooltipItems[i].index];
            }
          }
          return `Total: ${sum.toString()}`
        }
      }
    }
  }

  const handleTimeChange = (event, newTime) => {
    if (newTime !== null) {
      setTimeRange(newTime)
    }
  }

  const getSectionLabels = (metrics) => {
    const labels = new Set()
    Object.values(metrics).forEach(entry => {
      if (Object.keys(entry).length > 0) {
        Object.keys(entry).forEach(item => labels.add(item))
      }
    })
    return Array.from(labels)
  }

  return (
    <>
      <div className="panel_info">
        <TimeRangeIndicator timeRange={timeRange}
                            handleTimeChange={handleTimeChange}
                            className={"time_range_button_group"} />
      </div>
      <div className="panel_horizontal_graph_container">
        <>
          {
            isMetricsLoaded ?
              <>
                {
                  Object.keys(metrics).length > 0 ?
                    <StackedBarGraph data={metrics} options={entityGraphOptions}
                                     barLabels={Object.keys(metrics)}
                                     barPercentage={0.2}
                                     barSectionLabels={getSectionLabels(metrics)}
                                     className={"overview_insights_usage_graph"} /> :
                    <EmptyGraph />
                }
              </> :
              <Loader loading={!isMetricsLoaded}></Loader>
          }
        </>
      </div>
    </>
  )
}

export default EntityUsageGraph